import React from "react";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import DoneIcon from "@mui/icons-material/Done";
// import NotificationsIcon from "@mui/icons-material/Notifications";
import DangerousIcon from "@mui/icons-material/Dangerous";
import Config from "conFig.js";
import CheckboxTree from "react-checkbox-tree";
import Box from "@mui/material/Box";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import PropTypes from "prop-types";
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const usercolumns = [
  {
    field: "id",
    headerName: "Id",
    width: 50,
    headerAlign: "center",
    cellClassName: "center",
  },
  {
    field: "username",
    headerName: "Username",
    width: 200,
    cellClassName: "left",
    headerAlign: "center",
    flex: 1,
  },
];
const loaidvcolumns = [
  {
    field: "id",
    headerName: "Id",
    width: 50,
    headerAlign: "center",
    cellClassName: "center",
  },
  {
    field: "ten",
    headerName: "Loại",
    width: 200,
    cellClassName: "left",
    headerAlign: "center",
    flex: 1,
  },
];
const Label = ({ children }) => (
  <span style={{ fontSize: "0.875rem", color: "#000" }}>{children}</span>
);
export default function UsersDonVi() {
  const [users, setUsers] = React.useState([]);
  const [usersid, setUsersid] = React.useState(0);
  const [selecteduserRows, setSelecteduserRows] = React.useState([]);
  const [alert, setAlert] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [icon, setIcon] = React.useState(AddAlert);
  const [color, setColor] = React.useState("warning");

  const [loaidonvi, setLoaidonvi] = React.useState([]);
  const [loaidonviid, setLoaidonviid] = React.useState([]);
  const [checked, setChecked] = React.useState([]);
  const [filterText, setFilterText] = React.useState("");
  const [nodesFiltered, setNodesFiltered] = React.useState([]);

  const [nodes, setNodes] = React.useState([]);
  const [listDonvi, setListDonvi] = React.useState([]);
  const [disableBT, setDisableBT] = React.useState(true);
  const token = localStorage.getItem("token");
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  const getListUsers = () => {
    var url = Config.backend + "/api/users/getuser";
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setUsers(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getloaidonvi = () => {
    var url = Config.backend + "/api/Donvi/getdmloaidonvi?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setLoaidonvi(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const createParentNode = (array) => {
    var map = {};
    for (var i = 0; i < array.length; i++) {
      var obj = array[i];
      obj.children = [];

      map[obj.value] = obj;

      var parent = obj.chaId || "-";
      if (!map[parent]) {
        map[parent] = {
          children: [],
        };
      }
      map[parent].children.push(obj);
    }
    return map["-"].children;
  };
  const updateCheckedState = (node) => {
    const updatedValues = [node.value];
    if (node.checked) {
      setChecked([...updatedValues]);
    } else {
      const filteredChecks = checked.filter((check) => {
        return !updatedValues.includes(check);
      });
      setChecked(filteredChecks);
    }
  };
  const getListDonVi = (id) => {
    var url =
      Config.backend +
      "/api/Donvi/getdonvitheoloaidonvi?dmloaidonvi_id=" +
      id +
      "&username=" +
      username;
    fetch(url)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((data) => {
        if (data.length > 0) {
          setListDonvi(data);
          const result = data.map((a) => {
            return {
              value: a.id,
              label: <Label>{a.ten}</Label>,
              chaId: a.chaId,
            };
          });
          // console.log(result);
          var r = createParentNode(result);
          setNodes(r);
          setNodesFiltered(r);
        } else {
          setListDonvi([]);
          setNodes([]);
          setNodesFiltered([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const onFilterChange = (e) => {
    setFilterText(e.target.value);
  };
  const timkiem = (e) => {
    if (e.key === "Enter") {
      filterTree();
    }
  };

  const filterTree = () => {
    // Reset nodes back to unfiltered state
    if (!filterText || filterText === "" || filterText.length === 0) {
      setNodesFiltered(nodes);
      return;
    }

    const nodesFiltered = (nodes) => {
      return nodes.reduce(filterNodes, []);
    };

    setNodesFiltered(nodesFiltered);
  };

  const filterNodes = (filtered, node) => {
    const children = (node.children || []).reduce(filterNodes, []);
    if (
      // Node's label matches the search string
      node.label.props.children
        .toLocaleLowerCase()
        .indexOf(filterText.toLocaleLowerCase()) > -1 ||
      // Or a children has a matching node
      children.length
    ) {
      filtered.push({ ...node, ...(children.length && { children }) });
    }
    return filtered;
  };
  const showNotification = (ms, icon, color) => {
    setAlert(true);
    setMessage(ms);
    setColor(color);
    setIcon(icon);
    setTimeout(function () {
      setAlert(false);
    }, 3000);
  };
  const capnhat = () => {
    var dvql = 0;
    if (checked.length > 0) dvql = checked[0];
    let url = Config.backend + "/api/Users/themusersdvql";
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        user_id: usersid,
        dvql_id: dvql,
        dmloaidonvi_id: loaidonviid,
        username: username,
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response;
        }
        throw new Error("Something went wrong");
      })
      .then(() => {
        showNotification("Cập nhật thành công", DoneIcon, "success");
        getdonvitheouser();
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
        showNotification("Cập nhật thất bại", DangerousIcon, "danger");
      });
  };
  const findChild = (idFind, arr) => {
    listDonvi.forEach((item) => {
      if (item.chaId == idFind) {
        arr.push(item.id);
        findChild(item.id, arr);
      }
    });
    return arr;
  };
  const findParent = (idFind, arr) => {
    listDonvi.forEach((item) => {
      if (item.id == idFind) {
        arr.push(item.chaId);
        findParent(item.chaId, arr);
      }
    });
    return arr;
  };
  const getdonvitheouser = () => {
    if (selecteduserRows.length > 0 && selecteduserRows[0].username) {
      var url =
        Config.backend +
        "/api/donvi/getdonviquanlytheouser?dmloaidonvi_id=" +
        loaidonviid +
        "&username=" +
        selecteduserRows[0].username;
      fetch(url, obj)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((data) => {
          if (data.length > 0) {
            let arr = [];
            let parentArr = [];
            data.forEach((element) => {
              let chilArr = findChild(element.id, []);
              let findParentArr = findParent(element.id, []);
              arr = arr.concat(chilArr);
              parentArr = parentArr.concat(findParentArr);
              parentArr.push(element.id);
              arr.push(element.id);
            });
            setChecked(arr);
          } else {
            setChecked([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  React.useEffect(() => {
    getloaidonvi();
  }, []);
  React.useEffect(() => {
    getdonvitheouser();
  }, [selecteduserRows]);
  return (
    <GridContainer>
      <GridItem
        xs={12}
        sm={10}
        md={12}
        style={{ marginTop: 5, marginBottom: 10 }}
      >
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          disabled={disableBT}
          onClick={capnhat}
        >
          Cập nhật
        </Button>
      </GridItem>
      <GridItem xs={12} sm={10} md={4}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.id}
            rows={loaidonvi}
            columns={loaidvcolumns}
            rowsPerPageOptions={[]}
            //hideFooter={true}
            checkboxSelection={false}
            onRowClick={(params) => {
              getListDonVi(params.row.id);
              setLoaidonviid(params.row.id);
              getListUsers();
              setDisableBT(true);
            }}
            getRowHeight={() => "auto"}
            headerHeight={35}
            sx={datagridSx}
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={10} md={3}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.id}
            rows={users}
            columns={usercolumns}
            rowsPerPageOptions={[]}
            checkboxSelection={false}
            onSelectionModelChange={(ids) => {
              const selectedIDs = new Set(ids);
              const selectedRows = users.filter((row) =>
                selectedIDs.has(row.id)
              );
              setSelecteduserRows(selectedRows);
              setUsersid(selectedRows[0].id);
              setDisableBT(false);
            }}
            getRowHeight={() => "auto"}
            headerHeight={35}
            sx={datagridSx}
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
      <GridItem
        xs={12}
        sm={10}
        md={4}
        style={{
          border: "1px solid rgba(224, 224, 224, 1)",
          borderRadius: 4,
          marginLeft: 10,
        }}
      >
        <div style={{ height: "auto", width: "100%", margin: "10px 0px" }}>
          <input
            className="filter-text"
            placeholder="Search..."
            type="text"
            value={filterText}
            onKeyUp={timkiem}
            onChange={onFilterChange}
          />
          <CheckboxTree
            nodes={nodesFiltered}
            checked={checked}
            checkModel="all"
            showNodeIcon={false}
            nativeCheckboxes={true}
            expandOnClick={true}
            onCheck={(nodes, node) => {
              updateCheckedState(node);
            }}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={12} md={10} lg={8}>
        <Snackbar
          place="tc"
          color={color}
          icon={icon}
          message={message}
          open={alert}
          closeNotification={() => setAlert(false)}
          close
        />
      </GridItem>
    </GridContainer>
  );
}

Label.propTypes = {
  children: PropTypes.string,
};
